import { TableV2 } from '@medeloop/medeloop-components-library';
import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetOrganization } from 'src/api/organizations-queries';

export function AdminsTable() {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { organizationId } = useParams();

  const { data, isLoading } = useGetOrganization(organizationId);

  const admins = useMemo(() => data?.admins ?? [], [data]);

  const headers = [
    { label: 'First name', key: 'firstName' },
    { label: 'Last name', key: 'lastName' },
    { label: 'Email', key: 'email' },
    { label: 'Roles', key: 'roles' },
  ];

  const transformedData = useMemo(
    () =>
      admins
        .filter(
          (admin) =>
            admin.researcherGivenName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            admin.researcherFamilyName.toLowerCase().includes(searchTerm.toLowerCase()),
        )
        .map((admin) => ({
          id: admin.userId,
          firstName: admin.researcherGivenName,
          lastName: admin.researcherFamilyName,
          email: admin.researcherEmail,
          roles: admin.isAdmin ? 'Admin' : 'Member',
        })) ?? [],
    [admins, searchTerm],
  );

  return (
    <section className="flex flex-col w-full mt-12 border border-stroke-on-dark-subdued rounded-lg bg-background-dark-subdued px-4 py-6">
      <TableV2
        headers={headers}
        data={transformedData}
        searchPlaceholder="Search by name or email"
        onSearch={(t) => setSearchTerm(t)}
        isLoading={isLoading}
      />
    </section>
  );
}
